export const CONTACT = {
  phone: "+40 736 960 029",
  phoneHref: "tel:+40736960029",
  whatsapp: "https://wa.me/40736960029?text=Bun%C4%83%20ziua!%20V%C4%83%20contactez%20de%20pe%20site-ul%20Velierul%20Hope.%20A%C8%99%20dori%20detalii%20pentru%20o%20rezervare.",
  email: "rezervari@plimbaripemare.ro",
  emailHref: "mailto:rezervari@plimbaripemare.ro",
  location: "Marina Life Harbour, Limanu",
  season: "Sezonul 2027",
};

export const NAV_LINKS = [
  { name: "Acasă", path: "/", testid: "nav-link-home" },
  { name: "Nunți", path: "/nunti-pe-velier", testid: "nav-link-nunti" },
  { name: "Skipper Training", path: "/training-skipper", testid: "nav-link-skipper" },
  { name: "Balcik", path: "/excursii-balcik", testid: "nav-link-balcik" },
  { name: "Varna", path: "/excursii-varna", testid: "nav-link-varna" },
  { name: "Apus", path: "/apus-de-soare", testid: "nav-link-apus" },
  { name: "Croaziere", path: "/croaziere-pe-mare", testid: "nav-link-croaziere" },
  { name: "Team Building", path: "/team-building", testid: "nav-link-teambuilding" },
  { name: "Regate 2027", path: "/regate-2027", testid: "nav-link-regate" },
  { name: "Contact", path: "/contact", testid: "nav-link-contact" },
];

export const EXPERIENCES = [
  {
    title: "Nunți pe Velier",
    tagline: "Ceremonii și recepții cu Marea Neagră ca martor",
    path: "/nunti-pe-velier",
    testid: "experience-card-nunti",
    image: "https://images.pexels.com/photos/18028829/pexels-photo-18028829.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Miri pe puntea unui velier la apus",
  },
  {
    title: "Apus de Soare",
    tagline: "Croaziere de seară cu șampanie și lumină de aur",
    path: "/apus-de-soare",
    testid: "experience-card-apus",
    image: "https://images.unsplash.com/photo-1526761122248-c31c93f8b2b9?auto=format&fit=crop&w=1600&q=80",
    alt: "Velier în larg la apus de soare",
  },
  {
    title: "Excursii Balcik",
    tagline: "Două zile spre grădina de pe stânci a Bulgariei",
    path: "/excursii-balcik",
    testid: "experience-card-balcik",
    image: "https://images.pexels.com/photos/37858982/pexels-photo-37858982.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Stâncile de la Cap Kaliakra, lângă Balcik",
  },
  {
    title: "Excursii Varna",
    tagline: "Weekend la capitala mării: plecare vineri, retur duminică",
    path: "/excursii-varna",
    testid: "experience-card-varna",
    image: "/hope/varna-1.jpg",
    alt: "Plaja și stațiunile de lângă Varna, cu mare turcoaz",
  },
  {
    title: "Training Skipper",
    tagline: "Cursuri practice de navigație cu velierul",
    path: "/training-skipper",
    testid: "experience-card-skipper",
    image: "/hope/hope-10.webp",
    alt: "Cockpitul velierului Hope cu cârma — locul cursanților",
  },
  {
    title: "Croaziere pe Mare",
    tagline: "Călătorii de 2–5 zile de-a lungul coastei",
    path: "/croaziere-pe-mare",
    testid: "experience-card-croaziere",
    image: "https://images.pexels.com/photos/4934575/pexels-photo-4934575.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Velier în navigație pe mare deschisă",
  },
  {
    title: "Team Building",
    tagline: "Balcik în weekend: plecare vineri, întoarcere duminică",
    path: "/team-building",
    testid: "experience-card-teambuilding",
    image: "/hope/hope-2.jpg",
    alt: "Echipa urcă la bordul velierului Hope în Marina Life Harbour",
  },
  {
    title: "Regate 2027",
    tagline: "Pentru skipperi care vor să se afirme un sezon întreg",
    path: "/regate-2027",
    testid: "experience-card-regate",
    image: "/hope/regate-a.jpg",
    alt: "Flota de regată cu spinnakere colorate la start",
  },
];

export const HOPE_PHOTOS = [
  {
    src: "/hope/hope-3.webp",
    alt: "Velierul Hope sub pânze pe Marea Neagră, fotografiat de la cârmă",
    caption: "Sub pânze pe Marea Neagră",
  },
  {
    src: "/hope/hope-2.jpg",
    alt: "Pupa velierului Hope acostat în marina, cu numele vizibil la bord",
    caption: "Urcă la bord — Marina Life Harbour",
  },
  {
    src: "/hope/hope-1.jpg",
    alt: "Prova velierului Hope la chei, într-o zi senină de vară",
    caption: "Gata de plecare",
  },
  {
    src: "/hope/hope-4.jpg",
    alt: "Velierul Hope la pontonul de piatră, sub cer înnorat",
    caption: "Dimineți liniștite în port",
  },
  {
    src: "/hope/hope-6.webp",
    alt: "Cabina din provă a velierului Hope, cu pat dublu și lumină naturală de la trapă",
    caption: "Cabina din provă — dormit sub cerul liber",
  },
  {
    src: "/hope/hope-8.webp",
    alt: "Salonul velierului Hope cu canapele albastre și masă de lemn",
    caption: "Salonul — locul poveștilor de seară",
  },
  {
    src: "/hope/hope-9.webp",
    alt: "Bucătăria și masa de navigație din interiorul velierului Hope",
    caption: "Bucătărie completă, ca acasă",
  },
  {
    src: "/hope/hope-7.webp",
    alt: "Masa din salonul velierului Hope pregătită pentru cină, cu pahare de vin",
    caption: "Masa e pusă. Poveștile vin singure",
  },
  {
    src: "/hope/hope-10.webp",
    alt: "Cockpitul velierului Hope cu cârma, bimini și ghirlanda luminoasă",
    caption: "Cockpitul — aici stai la cârmă",
  },
  {
    src: "/hope/hope-11.jpg",
    alt: "Velierul Hope văzut din pupă în marina Life Harbour, cu logo-ul pe bordaj",
    caption: "Hope, acasă în Marina Life Harbour",
  },
];

export const IMAGES = {
  hero: {
    url: "https://images.pexels.com/photos/15141405/pexels-photo-15141405.jpeg?auto=compress&cs=tinysrgb&w=2000",
    alt: "Velier navigând liniștit pe Marea Neagră",
  },
  weddings: "https://images.pexels.com/photos/18028829/pexels-photo-18028829.jpeg?auto=compress&cs=tinysrgb&w=2000",
  training: "/hope/hope-10.webp",
  balchik: "https://images.pexels.com/photos/37858982/pexels-photo-37858982.jpeg?auto=compress&cs=tinysrgb&w=2000",
  sunset: "https://images.unsplash.com/photo-1526761122248-c31c93f8b2b9?auto=format&fit=crop&w=2000&q=80",
  cruises: "https://images.pexels.com/photos/4934575/pexels-photo-4934575.jpeg?auto=compress&cs=tinysrgb&w=2000",
};
